/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemUserDetectionFeedbackCreateDetectionFromJSON(json) {
    return WallItemUserDetectionFeedbackCreateDetectionFromJSONTyped(json, false);
}
export function WallItemUserDetectionFeedbackCreateDetectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}
export function WallItemUserDetectionFeedbackCreateDetectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'type': value.type,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemUserDetectionFeedbackCreateDetectionType;
(function (WallItemUserDetectionFeedbackCreateDetectionType) {
    WallItemUserDetectionFeedbackCreateDetectionType["FULLTEXT"] = "DETECTION_TYPE_FULL_TEXT";
    WallItemUserDetectionFeedbackCreateDetectionType["INVALID"] = "DETECTION_TYPE_INVALID";
    WallItemUserDetectionFeedbackCreateDetectionType["LABEL"] = "DETECTION_TYPE_LABEL";
    WallItemUserDetectionFeedbackCreateDetectionType["LOGO"] = "DETECTION_TYPE_LOGO";
    WallItemUserDetectionFeedbackCreateDetectionType["MODEL"] = "DETECTION_TYPE_MODEL";
    WallItemUserDetectionFeedbackCreateDetectionType["OBJECT"] = "DETECTION_TYPE_OBJECT";
    WallItemUserDetectionFeedbackCreateDetectionType["SAFESEARCH"] = "DETECTION_TYPE_SAFE_SEARCH";
    WallItemUserDetectionFeedbackCreateDetectionType["SERIAL"] = "DETECTION_TYPE_SERIAL";
    WallItemUserDetectionFeedbackCreateDetectionType["TEXT"] = "DETECTION_TYPE_TEXT";
})(WallItemUserDetectionFeedbackCreateDetectionType || (WallItemUserDetectionFeedbackCreateDetectionType = {}));
//# sourceMappingURL=WallItemUserDetectionFeedbackCreateDetection.js.map